import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { EssDetailsPopupComponent } from 'src/app/shared/popups/ess-details-popup/ess-details-popup.component';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import * as echarts from 'echarts';
import { Config } from 'src/app/app-constant';
import { FormBuilder } from '@angular/forms';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DatePipe } from '@angular/common';
import { EssDashboardPopupsComponent } from 'src/app/shared/popups/ess-dashboard-popups/ess-dashboard-popups.component';
import { ToastrService } from 'ngx-toastr'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-ess',
  templateUrl: './ess.component.html',
  styleUrls: ['./ess.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ESSComponent implements OnInit {
  loggedInUserRole: any;
  buttonColorName: any;
  selectedTypeTabName = 'Dashboard';
  selectedTypeTabIndex = 0;
  showSetupPopup: boolean = false;
  dropdownSettings: IDropdownSettings = {};
  subModuleButtonColor: any;
  ratingList = [
    {
      id: null,
      questionType: 'Rating Based',
      rating: null,
      ratingDefinition: ''
    },
  ];

  onSeletReminderOption: boolean = false;
  isShowReminderDate: any = false;

  dimensionsTemplateList = [
    {
      dimensionName: '',
      questions: [
        {
          id: null,
          question: '',
          questionNumber: null,
          questionType: null
        },
      ],
    },
  ];

  currentPageNumberOfSurveyMasterTable: any = 1;
  totalPagesOfSurveyMasterTable: any = 0;

  demo = [
    { ratings: '0' },
    { ratings: '1' },
    { ratings: '2' },
    { ratings: '3' },
    { ratings: '4' },
    { ratings: '5' },
  ];

  selectedSubTab: any = 'Completion Report';
  infoListData: any[] = []
  selectedYear: any = null;
  loggedInCompanyFiscalyear: any;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  selectedSurveyName: any = null;
  selectedSurveyStartDate: any = null;
  selectedSurveyEndDate: any = null;
  selectedSurveyStatus: any;
  isShowDashboardToHR: any;
  surveyDateOfJoining: any = null;
  intructionList: any = [];
  invitationEmailBody: any;
  invitationEmailSubject: any;
  submissionEmailBody: any;
  submissionEmailSubject: any;
  loggedInUserEmail: any;
  constructor(private encryptionService: EncryptionService, public router: Router, private activatedroute: ActivatedRoute,
    public dialog: MatDialog, public sharedService: SharedService,
    private loader: LoaderService,
    private httpService: HttpService, private config: Config, private fb: FormBuilder,
    private datePipe: DatePipe, private toastr: ToastrService, private pdfDownload: DownloadAsPdfService
  ) { }

  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserEmail = sessionStorage.getItem('userEmail');
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    if (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD' || this.loggedInUserRole === 'Employee') {
      this.selectedSubTab = 'Score Trend';
      this.selectedTypeTabName = 'My Master'
    } else {
      this.selectedSubTab = 'Completion Report';
      this.selectedTypeTabName = 'Dashboard';
    }
  }

  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      if (params?.operation == 'Setup') {
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin') {
          this.showSetupPopup = true;
          this.selectedTypeTabName = '';
          
          if (params?.id) {
            this.selectedSurveyID = params?.id;
            this.selectedYear = params?.year;
            this.selectedSurveyID = Number(this.selectedSurveyID);
            this.yearsOfCompanies();
            this.getessByID();
          } else {
            this.getYearsOfCompany();
          }
        }
      } else {
        this.showSetupPopup = false;
        this.selectedTypeTabIndex = params?.tabIndex;
        this.getYearsOfCompany();
      }
    })
  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/ess', { operation: operation }]);
  }

  onClickRedirectToDashboard() {
    this.router.navigate(['/home/hrportal/ess']);
  }

  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/essLogs', { operation: moduleName }]);

  }

  tabTypeChanged(event: MatTabChangeEvent): void {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;

    if (this.selectedTypeTabName == 'Reports') {
      this.essNamesForReports();
      this.getLocationsListEssReport();
      if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'HOD' ||
        this.loggedInUserRole == 'Manager') {
        this.essNamesOfUser();
      }
    }

    if (this.selectedTypeTabName == 'My Master') {
      this.getResponseOfSurveyByEmployeeID();
    }
  }

  onClickPublishBtn() {
    if (this.isPublished) {
      const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: "Survey is alreay published.",
          btn2: 'OK',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      return;
    }
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to Publish Survey?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.publishEss();
      }
    });
  }

  onClickOpenCreateSurveyPopup(popupName: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      popupName: popupName,
      moduleName: 'ESS',
      year: this.selectedYear,
      selectedLocationForSetup: this.selectedLocationForSetup,
      selectedBandForSetup: this.selectedBandForSetup,
      selectedGradeForSetup: this.selectedGradeForSetup,
      selectedFunctionForSetup: this.selectedFunctionForSetup,
      surveyDateOfJoining: this.surveyDateOfJoining,
      isPublished: this.isPublished,
      invitationEmailBody: this.invitationEmailBody,
      invitationEmailSubject: this.invitationEmailSubject,
      submissionEmailBody: this.submissionEmailBody,
      submissionEmailSubject: this.submissionEmailSubject,
      intructionList: this.intructionList,
      selectedEmployeeId: this.selectedEmployeeId,
      selectedSurveyID: this.selectedSurveyID,
      endDate: this.selectedSurveyEndDate
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(EssDetailsPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      
      if (popupName == 'Create Survey') {
        this.getessName();
      }
      if (popupName == 'Create Instructions') {
        this.intructionList = result;
      }
      if (popupName == 'Create Email Body') {
        this.invitationEmailBody = result?.invitationEmailBody;
        this.invitationEmailSubject = result?.invitationEmailSubject;
      }
      if (popupName == 'Submission Email') {
        this.submissionEmailBody = result?.submissionEmailBody;
        this.submissionEmailSubject = result?.submissionEmailSubject;
      }
      if (popupName == 'View Employees')
        this.selectedEmployeeId = result?.selectedEmployeeId
    });
  }

  createRatingAddTableRow() {
    this.ratingList.push({
      id: null,
      questionType: 'Rating Based',
      rating: null,
      ratingDefinition: ''
    });
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
  }

  createRatingRemoveTableRow(index: number) {
    if (this.ratingList.length > 1) {
      this.ratingList.splice(index, 1);
    }
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
  }
  isOpenEnded: boolean = false;
  isRatingBased: boolean = true;
  onQuestionTypeChange(row: any, index: any) {
    if (row.questionType === 'Open Ended') {
      this.ratingList[index].ratingDefinition = '';
    }
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
  }

  createTemplateAddTable() {
    this.dimensionsTemplateList.push({
      dimensionName: '',
      questions: [
        {
          id: null,
          question: '',
          questionNumber: null,
          questionType: null
        },
      ],
    });
  }

  createTemplateDeleteTable(tableIndex: number) {
    this.dimensionsTemplateList.splice(tableIndex, 1);
  }

  createTemplateAddTableRow(tableIndex: number) {
    const table = this.dimensionsTemplateList[tableIndex];
    table.questions.push({
      id: null,
      question: '',
      questionNumber: null,
      questionType: null
    });
  }

  createTemplateRemoveTableRow(tableIndex: number, rowIndex: number) {
    const table = this.dimensionsTemplateList[tableIndex];
    table.questions.splice(rowIndex, 1);
    if (table.questions.length > 0) {
      // table.questions[table.questions.length - 1].added = true;
    }
  }
  handleTypeChange(tableIndex: number, rowIndex: number, type: string) {
    const row = this.dimensionsTemplateList[tableIndex].questions[rowIndex];
    if (type === 'Rating Based') {
      // row.showOnlyRating = false;
      // row.showOnlyOpenEnded = false;
    } else if (type === 'Open Ended') {
      // row.showOnlyRating = true;
      // row.showOnlyOpenEnded = true;
    }
  }

  // -----------------------------------------Graph------------------------------------------
  demographicComparisonIcon: any = 'bar';
  demographicComparisonTable: any = false;
  completionStatusIcon: any = 'bar';
  completionStatusTableIcon: any = false;
  dimensionComparisonIcon: any = 'bar';
  dimensionComparisonTableIcon: any = false;
  trendAnalysisIcon: any = 'bar';
  trendAnalysisTableIcon: any = false;
  demographicTrendAnalysisIcon: any = 'bar';
  demographicTrendAnalysisTableIcon: any = false;

  demographicComparisonGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };
  completionStatusGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  // Demographic Comparison Graph 
  demographicComparisonGraph() { }

  switchDemographicComparisonGraphType(graphType: string) {
    this.demographicComparisonIcon = graphType;
    this.demographicComparisonTable = false;
    const dom = document.getElementById("demographicComparisonGraph") as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    if (graphType === 'bar') {
      this.demographicComparisonBarGraph(chartEmpTaskStatus);
    }
    if (graphType === 'pie') {
      this.demographicComparisonPieGraph(chartEmpTaskStatus);
    }
    if (graphType === 'line') {
      this.demographicComparisonLineGraph(chartEmpTaskStatus);
    }
  }

  demographicComparisonBarGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Score'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: this.demographicComparisonGraphData?.map((ele: any) => ele.name),
          name: 'Demographic',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      series: [
        {
          name: 'Score',
          type: 'bar',
          barWidth: '20',
          barGap: '15%',
          data: this.demographicComparisonGraphData?.map((ele: any) => ele.value),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          },
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  demographicComparisonPieGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E', '#BD3176'],
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Score',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: this.demographicComparisonGraphData,
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  demographicComparisonLineGraph(chartEmpTaskStatus: any) {
    const options = {
      xAxis: [
        {
          type: 'category',
          data: this.demographicComparisonGraphData?.map((ele: any) => ele.name),
          name: 'Demographic',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      tooltip: {
        trigger: 'axis',
      },
      series: [
        {
          name: 'Score',
          type: 'line',
          data: this.demographicComparisonGraphData?.map((ele: any) => ele.value),
        },
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchDemographicComparisonTable() {
    this.demographicComparisonIcon = '';
    this.demographicComparisonTable = true;
  }

  downloadDemographicComparisonGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearForDemoGraphicGraph);
    const servey = this.essNamesListForDashboardDemoGraphicsComparison.find((ele: any) => ele.id === this.selectedSurveyIDForDemoGraphicGraph);

    this.pdfDownload.ESSGraphPDFDownload(
      'demographicComparisonGraph', // chartId
      'demographicComparisonTable', // tableId
      'Demographic Comparison', // Title
      year, // Year
      servey?.name ? servey?.name : null, //Servey
      this.selectedDemoGraphicTypeForDemoGraphicGraph, //Demographic
    );
  }

  // Completion Status Graph

  switchCompletionStatusGraphType(graphType: string) {
    this.completionStatusIcon = graphType;
    this.completionStatusTableIcon = false;
    const dom = document.getElementById("completionStatusGraph") as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    if (graphType === 'bar') {
      this.completionStatusBarGraph(chartEmpTaskStatus);
    }
    if (graphType === 'pie') {
      this.completionStatusPieGraph(chartEmpTaskStatus);
    }
    if (graphType === 'line') {
      this.completionStatusLineGraph(chartEmpTaskStatus);
    }
  }

  completionStatusBarGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Submitted', 'Incomplete'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: this.completionStatusGraphData?.map((ele: any) => ele.name),
          name: 'Demographic',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
            }
          },
        },
      ],
      dataZoom: [{ // Add dataZoom here
        type: 'slider',
        start: 0,
        end: 100,
        handleSize: '100%',
        showDetail: false,
        xAxisIndex: [0],

      }],
      yAxis: {
        type: 'value',
        name: 'No. of Employees',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      series: [
        {
          name: 'Submitted',
          type: 'bar',
          barWidth: '20',
          barGap: '15%',
          data: this.completionStatusGraphData?.map((ele: any) => ele.submitted),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          },
        },

        {
          name: 'Incomplete',
          type: 'bar',
          barWidth: '20',
          barGap: '15%',
          data: this.completionStatusGraphData?.map((ele: any) => ele.incomplete),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          },
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  completionStatusPieGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E', '#BD3176'],
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Score',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: [10, 22, 28]
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  completionStatusLineGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      legend: {
        data: ['Submitted', 'Incomplete'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: this.completionStatusGraphData?.map((ele: any) => ele.name),
          name: 'Demographic',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value: any) {
              return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
            }
          },
        },
      ],
      dataZoom: [{ // Add dataZoom here
        type: 'slider',
        start: 0,
        end: 100,
        handleSize: '100%',
        showDetail: false,
        xAxisIndex: [0],

      }],
      yAxis: {
        type: 'value',
        name: 'No. of Employees',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      tooltip: {
        trigger: 'axis',
      },
      series: [
        {
          name: 'Submitted',
          type: 'line',
          data: this.completionStatusGraphData?.map((ele: any) => ele.submitted),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          },
        },

        {
          name: 'Incomplete',
          type: 'line',
          data: this.completionStatusGraphData?.map((ele: any) => ele.incomplete),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          },
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchCompletionStatusTable() {
    this.completionStatusIcon = '';
    this.completionStatusTableIcon = true;
  }

  downloadCompletionStatusGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearForCompletionStatusGraph);
    const servey = this.essNamesListForDashboardCompletionStatus.find((ele: any) => ele.id === this.selectedSurveyIDForCompletionStatusGraph);

    this.pdfDownload.ESSGraphPDFDownload(
      'completionStatusGraph', // chartId
      'completionStatusTable', // tableId
      'Completion Status', // Title
      year, // Year
      servey?.name ? servey?.name : null, //Servey
      this.selectedDemoGraphicTypeForCompletionStatusGraph, //Demographic
    );
  }

  // Dimension Comparison Graph

  switchDimensionComparisonGraphType(graphType: string) {
    this.dimensionComparisonIcon = graphType;
    this.dimensionComparisonTableIcon = false;
    const dom = document.getElementById("dimensionComparisonGraph") as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    if (graphType === 'bar') {
      this.dimensionComparisonBarGraph(chartEmpTaskStatus);
    }
    if (graphType === 'pie') {
      this.dimensionComparisonPieGraph(chartEmpTaskStatus);
    }
    if (graphType === 'line') {
      this.dimensionComparisonLineGraph(chartEmpTaskStatus);
    }
  }

  dimensionComparisonBarGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Score'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: this.dimensionComparisonData?.map((ele: any) => ele.name),
          name: 'Dimension',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      series: [
        {
          name: 'Score',
          type: 'bar',
          barWidth: '20',
          barGap: '15%',
          data: this.dimensionComparisonData?.map((ele: any) => ele.value),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          },
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  dimensionComparisonPieGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E', '#BD3176'],
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Score',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: this.dimensionComparisonData
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  dimensionComparisonLineGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      xAxis: [
        {
          type: 'category',
          data: this.dimensionComparisonData?.map((ele: any) => ele.name),
          name: 'Dimension',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      tooltip: {
        trigger: 'axis',
      },
      series: [
        {
          name: 'Score',
          type: 'line',
          data: this.dimensionComparisonData?.map((ele: any) => ele.value),
        },
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchDimensionComparisonTable() {
    this.dimensionComparisonIcon = '';
    this.dimensionComparisonTableIcon = true;
  }

  downloadDimensionComparisonGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearForDimensionComparisonGraph);
    const servey = this.essNamesListForDashboardDimensionComparison.find((ele: any) => ele.id === this.selectedSurveyIDForDimensionComparisonGraph);

    this.pdfDownload.ESSGraphPDFDownload(
      'dimensionComparisonGraph', // chartId
      'dimensionComparisonTable', // tableId
      'Dimension Comparison', // Title
      year, // Year
      servey?.name ? servey?.name : null, //Servey
      null, //Demographic
    );
  }
  // Trend Analysis Graph

  switchTrendAnalysisGraphType(graphType: string) {
    this.trendAnalysisIcon = graphType;
    this.trendAnalysisTableIcon = false;
    const dom = document.getElementById("trendAnalysisGraph") as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    if (graphType === 'bar') {
      this.trendAnalysisBarGraph(chartEmpTaskStatus);
    }
    if (graphType === 'pie') {
      this.trendAnalysisPieGraph(chartEmpTaskStatus);
    }
    if (graphType === 'line') {
      this.trendAnalysisLineGraph(chartEmpTaskStatus);
    }
  }

  trendAnalysisBarGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Score'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: this.trendAnalysisData?.map((ele: any) => ele.name),
          name: 'Survey Name',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      series: [
        {
          name: 'Score',
          type: 'bar',
          barWidth: '20',
          barGap: '15%',
          data: this.trendAnalysisData?.map((ele: any) => ele.value),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000'
          },
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  trendAnalysisPieGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E', '#BD3176'],
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Score',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: this.trendAnalysisData
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  trendAnalysisLineGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E'],
      xAxis: [
        {
          type: 'category',
          data: this.trendAnalysisData?.map((ele: any) => ele.value),
          name: 'Survey Name',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      tooltip: {
        trigger: 'axis',
      },
      series: [
        {
          name: 'Score',
          type: 'line',
          data: this.trendAnalysisData?.map((ele: any) => ele.value),
        },
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchTrendAnalysisTable() {
    this.trendAnalysisIcon = '';
    this.trendAnalysisTableIcon = true;
  }

  downloadTrendAnalysisGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearForTrendAnalysisGraph);
    const servey = this.essNamesListForDashboardtrendAnalysis.find((ele: any) => ele.id === this.selectedSurveyIDForTrendAnalysisGraph);

    this.pdfDownload.ESSGraphPDFDownload(
      'trendAnalysisGraph', // chartId
      'trendAnalysisTable', // tableId
      'Trend Analysis', // Title
      year, // Year
      servey?.name ? servey?.name : null, //Servey
      null, //Demographic
    );
  }

  // Demographic Trend Analysis

  switchDemographicTrendAnalysisGraphType(graphType: string) {
    this.demographicTrendAnalysisIcon = graphType;
    this.demographicTrendAnalysisTableIcon = false;
    const dom = document.getElementById("demographicTrendAnalysisGraph") as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    chartEmpTaskStatus.clear();
    if (graphType === 'bar') {
      this.demographicTrendAnalysisBarGraph(chartEmpTaskStatus);
    }
    if (graphType === 'pie') {
      this.demographicTrendAnalysisPieGraph(chartEmpTaskStatus);
    }
    if (graphType === 'line') {
      this.demographicTrendAnalysisLineGraph(chartEmpTaskStatus);
    }
  }

  demographicTrendAnalysisBarGraph(chartEmpTaskStatus: any) {
    const data = this.demographicTrendAnalysisData;
    const xAxisData = data.map((item: { demographicName: any; }) => item.demographicName); // x-axis labels
    const surveyNames = [...new Set(data.flatMap((item: { surveys: any[]; }) => item.surveys.map(s => s.surveyName)))]; // Unique survey names

    const series = surveyNames.map(surveyName => ({
      name: surveyName,
      type: 'bar',
      barWidth: '20',
      label: {
        show: true,
        position: 'top',
        fontSize: 10,
        color: '#000'
      },
      emphasis: {
        focus: 'series'
      },
      data: data.map((item: { surveys: any[]; }) => {
        const survey = item.surveys.find(s => s.surveyName === surveyName);
        return survey ? survey.score : 0;
      })
    }));
    const options = {
      color: ['#393186', '#F3820E', '#BD3176', '#01A601'],
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Score'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: xAxisData,
          name: 'Score',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Demographic',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
        }
      },
      series: series
    };
    chartEmpTaskStatus.setOption(options);
  }

  demographicTrendAnalysisPieGraph(chartEmpTaskStatus: any) {
    const options = {
      color: ['#393186', '#F3820E', '#BD3176'],
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Score',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: [10, 22, 28]
        }
      ]
    };
    chartEmpTaskStatus.setOption(options);
  }

  demographicTrendAnalysisLineGraph(chartEmpTaskStatus: any) {
    const data = this.demographicTrendAnalysisData;
    const xAxisData = data.map((item: { demographicName: any; }) => item.demographicName); // x-axis labels
    const surveyNames = [...new Set(data.flatMap((item: { surveys: any[]; }) => item.surveys.map(s => s.surveyName)))]; // Unique survey names

    const series = surveyNames.map(surveyName => ({
      name: surveyName,
      type: 'line',
      label: {
        show: true,
        position: 'top',
        fontSize: 10,
        color: '#000'
      },
      emphasis: {
        focus: 'series'
      },
      data: data.map((item: { surveys: any[]; }) => {
        const survey = item.surveys.find(s => s.surveyName === surveyName);
        return survey ? survey.score : 0;
      })
    }));
    const options = {
      xAxis: [
        {
          type: 'category',
          data: xAxisData,
          name: 'Score',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
      },
      tooltip: {
        trigger: 'axis',
      },
      series: series
    };
    chartEmpTaskStatus.setOption(options);
  }

  switchDemographicTrendAnalysisTable() {
    this.demographicTrendAnalysisIcon = '';
    this.demographicTrendAnalysisTableIcon = true;
  }

  downloadDemographicTrendAnalysisGraph() {
    const year = this.sharedService.transformYearToFyFormat(this.selectedYearForDemoGraphicTrendAnalysisGraph);
    const selectedSurveyIds = this.selectedSurveyIDForDemoGraphicTrendAnalysisGraph.map((ele: any) => ele.id);
    const selectedSurveys = this.essNamesListForDashboardDemoGraphicsTrendAnalysis.filter((ele: any) =>
      selectedSurveyIds.includes(ele.id)
    );

    this.pdfDownload.ESSGraphPDFDownload(
      'demographicTrendAnalysisGraph', // chartId
      'demographicTrendAnalysisTable', // tableId
      'Demographic Trend Analysis', // Title
      year, // Year
      selectedSurveys.map((survey: any) => survey.name).join(', ') || null, // Servey
      this.selectedDemoGraphicTypeForDemoGraphicTrendAnalysisGraph, // Demographic
    );
  }


  showInfoPopup: any = false
  // -----------------------------------------My Master---------------------------------------
  toggleInfoPopup() {
    this.showInfoPopup = !this.showInfoPopup;
  }
  // -----------------------------------------Reports-----------------------------------------


  showScoreCardReport(buttonName: any) {
    this.selectedSubTab = buttonName;
    this.searchStringReport = null;
    this.essNamesForReports()
  }


  onSelectEssReportScoreTrend() {
    this.onChangeSurveyNameOfReport();
  }
  onDeSelectEssReportScoreTrend() {
    this.onChangeSurveyNameOfReport();
  }
  selectAllEssReportScoreTrend(data: any) {
    this.multipleSelectedEssIDs = data;
    this.onChangeSurveyNameOfReport();
  }
  onDeSelectAllEssReportScoreTrend() {
    this.multipleSelectedEssIDs = []
    this.onChangeSurveyNameOfReport();
  }

  onSelectEssReportDepartment() { }
  onDeSelectEssReportDepartment() { }
  selectAllEssReportDepartment(data: any) { }
  onDeSelectAllEssReportDepartment() { }

  onSelectEssReportBand() { }
  onDeSelectEssReportBand() { }
  selectAllEssReportBand(data: any) { }
  onDeSelectAllEssReportBand() { }

  onSelectEssReportLocation() { }
  onDeSelectEssReportLocation() { }
  selectAllEssReportLocation(data: any) { }
  onDeSelectAllEssReportLocation() { }

  onSelectEssReportEmployee() { }
  onDeSelectEssReportEmployee() { }
  selectAllEssReportEmployee(data: any) { }
  onDeSelectAllEssReportEmployee() { }

  yearsOfCompany: any = [];
  selectedSurveyID: any;
  selectedYearForDemoGraphicGraph: any;
  selectedSurveyIDForDemoGraphicGraph: any;
  selectedDemoGraphicTypeForDemoGraphicGraph: any = 'Department';
  selectedYearForCompletionStatusGraph: any;
  selectedSurveyIDForCompletionStatusGraph: any;
  selectedDemoGraphicTypeForCompletionStatusGraph: any = 'Department';

  selectedYearForDimensionComparisonGraph: any;
  selectedSurveyIDForDimensionComparisonGraph: any;
  selectedYearForTrendAnalysisGraph: any;
  selectedSurveyIDForTrendAnalysisGraph: any;
  selectedYearForDemoGraphicTrendAnalysisGraph: any;
  selectedSurveyIDForDemoGraphicTrendAnalysisGraph: any = [];
  selectedDemoGraphicTypeForDemoGraphicTrendAnalysisGraph: any = 'Department';

  getYearsOfCompany() {
    
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.yearsOfCompany = [];
      data?.data?.yearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        }
        if (test[0] != null && test[1] != null) {
          this.yearsOfCompany.push(obj);
        }
      });
      
      this.yearsOfCompany?.forEach((ele: any) => {
        const currentYear = new Date().getFullYear();
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        let yearValue = '';
        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue = `${currentYear}-${currentYear}`;
        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;
          if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
            if (currentMonth < 3) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if (this.loggedInCompanyFiscalyear === 'July_Jun') {
            if (currentMonth < 6) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
            if (currentMonth < 9) {
              yearValue = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
        }

        if (ele?.year == yearValue) {
          this.selectedYear = ele?.year;
          this.selectedYearForDemoGraphicGraph = ele?.year;
          this.selectedYearForCompletionStatusGraph = ele?.year;
          this.selectedYearForDimensionComparisonGraph = ele?.year;
          this.selectedYearForTrendAnalysisGraph = ele?.year;
          this.selectedYearForDemoGraphicTrendAnalysisGraph = ele?.year;
        }
      });
      if (this.showSetupPopup) {
        this.getLocationsListForEssSetup();
        this.getessName();
      } else {
        this.surveyMasterYearSelectionChange();
      }
      
      if (this.selectedTypeTabName == 'My Master') {
        this.essNamesOfUser();
      }
      if (this.selectedTypeTabName == 'Dashboard') {
        this.essNamesActiveAndCompleted();
      }
      if (this.selectedTypeTabName == 'Reports') {
        this.essNamesForReports();
      }
    })
  }
  yearsOfCompanies() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.yearsOfCompany = [];
      data?.data?.yearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        }
        if (test[0] != null && test[1] != null) {
          this.yearsOfCompany.push(obj);
        }
      });
      if (this.showSetupPopup) {
        this.getLocationsListForEssSetup();
      } else {
        this.surveyMasterYearSelectionChange();
      }
      if (this.selectedTypeTabName == 'My Master') {
        this.essNamesOfUser();
      } else {
        this.getessName();
      }
    })
  }
  essNamesList: any = [];
  essNamesListForUser: any = [];
  isSelectedYearIsSameYeartoCurrentYear: boolean = false;
  getMonthIndex(monthName: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());
  }

  getessName() {
    if (this.selectedYear != null) {
      const test = this.selectedYear?.split('-');
      
      var endMonth = this.loggedInCompanyFiscalyear?.split('_')
      const currentDate = new Date();
      const monthToCheck = new Date(test[1], this.getMonthIndex(this.sharedService.transform(endMonth[1])), 30);
      monthToCheck.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);
      this.isSelectedYearIsSameYeartoCurrentYear = currentDate.getTime() < monthToCheck.getTime();

      this.httpService.callGetService(this.config.getessName + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
        
        this.essNamesList = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.essName,
          }
          this.essNamesList.push(obj);
        });
        var obj = data?.data?.find((ele:any)=>ele.essStatus == 'Active')
        if (obj.essStatus == 'Active') {
          this.selectedSurveyID = obj.id;
          this.getessByID()
        } else {
          this.selectedSurveyID = null;
          this.selectedSurveyName = null;
          this.selectedSurveyStartDate = null;
          this.selectedSurveyEndDate = null;
          this.selectedSurveyStatus = null;
          this.isShowDashboardToHR = false;
          this.isPublished = false;
          this.selectedEmployeeId = [];
          this.selectedLocationForSetup = [];
          this.selectedBandForSetup = [];
          this.selectedGradeForSetup = [];
          this.selectedFunctionForSetup = [];
          this.surveyDateOfJoining = null;
          this.onSeletReminderOption = false;
          this.selectedTemplateColorName = 'Red';
          this.intructionList = [];
          this.ratingList = [
            {
              id: null,
              questionType: 'Rating Based',
              rating: null,
              ratingDefinition: ''
            },
          ]
          this.dimensionsTemplateList = [
            {
              dimensionName: '',
              questions: [
                {
                  id: null,
                  question: '',
                  questionNumber: null,
                  questionType: null
                },
              ],
            },
          ];
        }
        if (data?.data?.length == 0) {
          this.selectedSurveyID = null;
          if (this.selectedTypeTabName == 'Reports') {
            this.onChangeSurveyNameOfReport();
          }
        } else {
          if (this.selectedTypeTabName == 'Reports') {
            this.onChangeSurveyNameOfReport();
          }
        }
      })
    }
  }
  essNamesListForReports: any = []
  essNamesForReports() {
    const test = this.selectedYear?.split('-');
    this.httpService.callGetService(this.config.essNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.essNamesListForReports = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.essName,
        }
        this.essNamesListForReports.push(obj);
      });
      var obj = data?.data?.find((ele:any)=>ele.essStatus == 'Active')
      if (obj.essStatus == 'Active') {
        this.selectedSurveyID = obj.id;
        this.getessByID()
      } else {
        this.selectedSurveyID = null;
        this.selectedSurveyName = null;
        this.selectedSurveyStartDate = null;
        this.selectedSurveyEndDate = null;
        this.selectedSurveyStatus = null;
        this.isShowDashboardToHR = false;
        this.isPublished = false;
        this.selectedEmployeeId = [];
        this.selectedLocationForSetup = [];
        this.selectedBandForSetup = [];
        this.selectedGradeForSetup = [];
        this.selectedFunctionForSetup = [];
        this.surveyDateOfJoining = null;
        this.onSeletReminderOption = false;
        this.selectedTemplateColorName = 'Red';
        this.intructionList = [];
        this.ratingList = [
          {
            id: null,
            questionType: 'Rating Based',
            rating: null,
            ratingDefinition: ''
          },
        ]
        this.dimensionsTemplateList = [
          {
            dimensionName: '',
            questions: [
              {
                id: null,
                question: '',
                questionNumber: null,
                questionType: null
              },
            ],
          },
        ];
      }
      this.multipleSelectedEssIDs = this.essNamesListForReports
      if (data?.data?.length == 0) {
        this.selectedSurveyID = null;
        if (this.selectedTypeTabName == 'Reports') {
          this.onChangeSurveyNameOfReport();
        }
      } else {
        if (this.selectedTypeTabName == 'Reports') {
          this.onChangeSurveyNameOfReport();
        }
      }
    })
  }
  essNamesOfUser() {
    const test = this.selectedYear?.split('-');
    this.selectedSurveyID = null
    this.httpService.callGetService(this.config.essNamesOfUser + this.loggedInUserId + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.essNamesListForUser = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.essName,
        }
        this.essNamesListForUser.push(obj);
      });
      if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'HOD' ||
        this.loggedInUserRole == 'Manager') {
        if (this.essNamesListForUser.length != 0) {
          this.essNamesListForDashboard = this.essNamesListForUser[0].id;
          this.selectedSurveyID = this.essNamesListForUser[0].id;
          this.isResponseSubmitted();
          this.getessByID()
        } else {
          this.essNamesListForDashboard = null;
          this.selectedSurveyID = null;
        }
      }
    })
  }
  mySurveyQuestionList: any = [];
  ratingListOnRatingBased: any = [];
  isPublished: boolean = false;

  getessByID() {
    this.httpService.callGetService(this.config.getessByID + this.selectedSurveyID).subscribe((data: any) => {
      this.selectedSurveyName = data?.data?.essName;
      this.selectedSurveyStartDate = data?.data?.startDate;
      this.selectedSurveyEndDate = data?.data?.endDate;
      this.selectedSurveyStatus = data?.data?.essStatus;
      this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr ? data?.data?.isReportsVisibleToHr : false;
      this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
      this.selectedDatesForReminder = data?.data?.reminderDate;
      if (data?.data?.reminderDate?.length != 0) {
        this.latestSelectedDate = data?.data?.reminderDate[0];
      }
      this.selectedEmployeeId = [];
      data?.data?.employee?.forEach((ele: any) => {
        let obj = {
          id: ele
        }
        this.selectedEmployeeId.push(obj);
      })
      this.selectedEmployeeForReport = data?.data?.employee;
      this.selectedLocationForSetup = [];
      data?.data?.location.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedLocationForSetup.push(obj)
      })
      this.selectedBandForSetup = [];
      data?.data?.band.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedBandForSetup.push(obj)
      })
      this.selectedGradeForSetup = [];
      data?.data?.grade.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedGradeForSetup.push(obj)
      })
      this.selectedFunctionForSetup = [];
      data?.data?.department.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedFunctionForSetup.push(obj)
      })
      this.surveyDateOfJoining = data?.data?.surveyCutoff;
      this.onSeletReminderOption = data?.data?.isReminderOn;
      this.selectedTemplateColorName = data?.data?.templateName ? data?.data?.templateName : 'Red';

      this.templateColorList.forEach((ele: any) => {
        if (ele.colorName == data?.data?.templateName) {
          this.selectedTemplateColorCode = ele.stripcolor;
          this.selectedtemplateBgColor = ele.backgroundColor;
        }
      })

      if (data?.data?.instruction?.length != 0) {
        this.intructionList = data?.data?.instruction;
      }
      if (data?.data?.ratings?.length != 0) {
        this.ratingList = data?.data?.ratings;
      } else {
        this.ratingList = [
          {
            id: null,
            questionType: 'Rating Based',
            rating: null,
            ratingDefinition: ''
          },
        ]
      }
      this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
      this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
      if (data?.data?.questions?.length != 0) {
        this.dimensionsTemplateList = data?.data?.questions;
      } else {
        this.dimensionsTemplateList = [
          {
            dimensionName: '',
            questions: [
              {
                id: null,
                question: '',
                questionNumber: null,
                questionType: null
              },
            ],
          },
        ];
      }
      this.invitationEmailBody = data?.data?.invitationEmailBody;
      this.invitationEmailSubject = data?.data?.invitationEmailSubject;
      this.submissionEmailBody = data?.data?.submissionEmailBody;
      this.submissionEmailSubject = data?.data?.submissionEmailSubject;

      this.mySurveyQuestionList = data?.data?.questions.flatMap((dimension: { questions: any; }) => dimension.questions);
      this.mySurveyQuestionList = this.mySurveyQuestionList.map((question: any) => ({
        ...question,
        answer: '' // You can set a default value or any specific value
      }));
      this.ratingListOnRatingBased = [];
      data?.data?.ratings.forEach((ele: any) => {
        if (ele.questionType == 'Rating Based') {
          this.ratingListOnRatingBased.push(ele)
        }
      })
      if (this.selectedTypeTabName == 'My Master') {
        this.getResponseOfSurveyByEmployeeID();
      }
      if (this.selectedLocationForSetup.length != 0) {
        if (this.selectedTypeTabName == 'Reports') {
          this.getLocationsListEssReport();
          this.getBandsListForEssForReport();
          this.getGradesListForEssForReport();
          this.getDeptListForEssForReport();
          this.getEmpListForEssForReport();
        } else {
          this.getLocationsListForEssSetup();
          this.getBandsListForEssSetup();
          this.getGradesListForEssSetup();
          this.getDeptListForEssSetup();
        }
      }
    })
  }
  getEssByIdForDashboard() {
    this.httpService.callGetService(this.config.getessByID + this.selectedSurveyIDForDashboardGlobal).subscribe((data: any) => {
      this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr ? data?.data?.isReportsVisibleToHr : false;
      this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
    })
  }
  isRatingDuplicate: boolean = false;
  updateSurvey() {
    // if (this.isPublished) {
    //   const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
    //     disableClose: true,
    //     height: '25%',
    //     width: '30%',
    //     data: {
    //       msg: "Survey is alreay published.",
    //       btn2: 'OK',
    //       btn2BgColor: this.buttonColorName,
    //       showSuccessIcon: true,
    //       showSuccessMessage: false,
    //       showCloseIcon: false
    //     },
    //   });
    //   return;
    // }
    
    const test = this.selectedYear?.split('-');
    var flag = true;
    if (this.selectedBandForSetup.length == 0) { flag = false };
    if (this.selectedFunctionForSetup.length == 0) { flag = false };
    if (this.selectedEmployeeId.length == 0) { flag = false };
    if (this.selectedGradeForSetup.length == 0) { flag = false };
    if (this.selectedLocationForSetup.length == 0) { flag = false };
    if (this.selectedTemplateColorName == null) { flag = false };
    if (this.surveyDateOfJoining == null) { flag = false };
    if (this.ratingList?.some((ele: any) =>
      ele.questionType == 'Rating Based' && ele.rating == null)) { flag = false }
    if (this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based' && ele.ratingDefinition == '')) { flag = false }
    for (let dimension of this.dimensionsTemplateList) {
      if (dimension.dimensionName === '' || dimension.questions.some(q => q.question === '')) {
        flag = false;
        break;
      }
    }
    var tempRatings: any = [];
    this.isRatingDuplicate = false;
    for (let item of this.ratingList) {
      if (tempRatings.includes(item.rating)) {
        flag = false;
        this.isRatingDuplicate = true;
        break;
      }
      tempRatings.push(item.rating);
    }
    var reminderDates: any = [];
    if (this.onSeletReminderOption) {
      if (this.selectedDatesForReminder.length == 0) { flag = false }
      this.selectedDatesForReminder?.forEach((ele: any) => {
        reminderDates.push(this.datePipe.transform(ele, "yyyy-MM-dd"));
      });
    } else {
      reminderDates = [];
    }
    if (flag) {
      const request = {
        "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
        "companyId": this.loggedInUserCompanyID,
        "department": this.selectedFunctionForSetup?.map((ele: { id: any; }) => ele.id),
        "dimension": this.dimensionsTemplateList,
        "employee": this.selectedEmployeeId?.map((ele: { id: any; }) => ele.id),
        "endDate": this.datePipe.transform(this.selectedSurveyEndDate, "yyyy-MM-dd"),
        "essName": this.selectedSurveyName,
        "essStatus": this.selectedSurveyStatus,
        "fromYear": test[0],
        "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
        "id": this.selectedSurveyID,
        "instruction": this.intructionList,
        "invitationEmailBody": this.invitationEmailBody,
        "invitationEmailSubject": this.invitationEmailSubject,
        "isReminderOn": this.onSeletReminderOption,
        "isReportsVisibleToHr": this.isShowDashboardToHR,
        "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
        "ratings": this.ratingList,
        "reminderDate": reminderDates,
        "startDate": this.datePipe.transform(this.selectedSurveyStartDate, "yyyy-MM-dd"),
        "submissionEmailBody": this.submissionEmailBody,
        "submissionEmailSubject": this.submissionEmailSubject,
        "surveyCutoff": this.datePipe.transform(this.surveyDateOfJoining, "yyyy-MM-dd"),
        "templateName": this.selectedTemplateColorName,
        "toYear": test[1]
      }
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.essSave, request).
        subscribe((data: any) => {
          this.loader.dismissLoader();
          if (data?.status) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.isEditActive = false;
            });
            this.getessByID()
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {

            });
          }
        })
    } else {
      if (this.isRatingDuplicate) {
        this.toastr.error('Rating is duplicate', '', {
          timeOut: 3000,
        });
      }
      this.toastr.error('Please fill all mandetory fields.', '', {
        timeOut: 3000,
      });
    }

  }
  isEditActive: boolean = false;
  editSurvey() {
    this.isEditActive = true;
  }
  closeSurveyEdit() {
    this.isEditActive = false;
    this.getessByID();
  }
  selectedTemplateColorName: any = 'Red';
  selectedTemplateColorCode: any = '#F6921E';
  selectedtemplateBgColor: any;
  templateColorList = [
    {
      stripcolor: "#db4437",
      backgroundColor: "#fae3e1",
      colorName: "Red"
    },
    {
      stripcolor: "#673ab7",
      backgroundColor: "#f0ebf8",
      colorName: "Purple"
    },
    {
      stripcolor: "#3f51b5",
      backgroundColor: "#eceef8",
      colorName: "Indigo"
    }, {
      stripcolor: "#4285f4",
      backgroundColor: "#e3edfd",
      colorName: "Blue"
    },
    {
      stripcolor: "#03a9f4",
      backgroundColor: "#d9f2fd",
      colorName: "Light Blue"
    },
    {
      stripcolor: "#00bcd4",
      backgroundColor: "#d9f5f9",
      colorName: "Cyan"
    },
    {
      stripcolor: "#ff5722",
      backgroundColor: "#ffe6de",
      colorName: "Red Orange"
    },

    {
      stripcolor: "#ff9800",
      backgroundColor: "#fff0d9",
      colorName: "Orange"
    },
    {
      stripcolor: "#009688",
      backgroundColor: "#d9efed",
      colorName: "Teal"
    },
    {
      stripcolor: "#4caf50",
      backgroundColor: "#e4f3e5",
      colorName: "Green"
    },
    {
      stripcolor: "#607d8b",
      backgroundColor: "#e7ecee",
      colorName: "Blue Gray"
    },
    {
      stripcolor: "#9e9e9e",
      backgroundColor: "#f0f0f0",
      colorName: "Gray"
    },
  ]
  searchString: any = '';
  listOfEss: any = [];
  debounceTimer: any;
  selectedSizeToShowData: any = 25;
  sortByName: any;
  onSearchInput(event: any) {
    this.searchString = event.target.value;
    if (this.searchString == '') {
      this.searchString = null;
    } if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.surveyMasterYearSelectionChange();
    }, 300);
  }
  isShowCheckBox: boolean = false;
  surveyMasterYearSelectionChange() {
    const test = this.selectedYear?.split('-');
    var srearchString
    if (this.searchString == '') {
      srearchString = 'All'
    } else {
      srearchString = this.searchString
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' +
      test[0] + '/' + test[1] + '/' + srearchString
    ).subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listOfEss = data?.data?.ess?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.ess?.every((ele: any) => ele.essStatus == 'Active')
    })
  }
  onSortAssending(sortName: any) {
    this.sortByName = sortName
    const test = this.selectedYear?.split('-');
    var srearchString
    if (this.searchString == '') {
      srearchString = 'All'
    } else {
      srearchString = this.searchString
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' +
      test[0] + '/' + test[1] + '/' + srearchString + '?page=' + 0 + '&size=' + this.selectedSizeToShowData + '&sort=' + sortName + ',asc'
    ).subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listOfEss = data?.data?.ess?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.ess?.every((ele: any) => ele.essStatus == 'Active')
    })
  }
  onSortDesending(sortName: any) {
    this.sortByName = sortName
    const test = this.selectedYear?.split('-');
    var srearchString
    if (this.searchString == '') {
      srearchString = 'All'
    } else {
      srearchString = this.searchString
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' +
      test[0] + '/' + test[1] + '/' + srearchString + '?page=' + 0 + '&size=' + this.selectedSizeToShowData + '&sort=' + sortName + ',desc'
    ).subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listOfEss = data?.data?.ess?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.ess?.every((ele: any) => ele.essStatus == 'Active')
    })
  }
  totalNoOfPages: any = 0;
  currentPage: any = 1;
  totalCount: any = 0;
  page: any = 0;
  pageChangeEss() {
    const test = this.selectedYear?.split('-');
    var srearchString
    if (this.searchString == '') {
      srearchString = 'All'
    } else {
      srearchString = this.searchString
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' +
      test[0] + '/' + test[1] + '/' + srearchString + '?page=' + this.page + '&size=' +
      this.selectedSizeToShowData + '&sort=' + this.sortByName + ',asc'
    ).subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listOfEss = data?.data?.ess?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.ess?.every((ele: any) => ele.essStatus == 'Active')
    })
  }
  sizeChange() {
    const test = this.selectedYear?.split('-');
    var srearchString
    if (this.searchString == '') {
      srearchString = 'All'
    } else {
      srearchString = this.searchString
    }
    this.httpService.callGetService(this.config.getAllEss + this.loggedInUserCompanyID + '/' +
      test[0] + '/' + test[1] + '/' + srearchString + '?page=' + 0 + '&size=' +
      this.selectedSizeToShowData + '&sort=' + this.sortByName + ',asc'
    ).subscribe((data: any) => {
      this.totalNoOfPages = data.data?.totalPages;
      this.totalCount = data.data?.total;
      this.currentPage = data.data?.currentPageNumber + 1;
      this.listOfEss = data?.data?.ess?.map((ele: any) => ({
        ...ele,
        isChecked: false
      }));
      this.isShowCheckBox = data?.data?.ess?.every((ele: any) => ele.essStatus == 'Active')
    })
  }
  previousPageEss() {
    if (this.currentPage < 2) {
      return;
    } else {
      this.currentPage--;
      this.page--;
      this.pageChangeEss();
    }
  }
  nextPageEss() {
    if (this.currentPage >= this.currentPage) {
      return;
    }
    if (this.currentPage == 1) {
      this.page = 1;
    } else {
      this.page++;
    }
    this.currentPage++;
    this.pageChangeEss();
  }

  getLocationList: any = [];
  selectedLocationForSetup: any = [];
  getBandList: any = [];
  selectedBandForSetup: any = [];
  getGradeList: any = [];
  selectedGradeForSetup: any = [];
  getFunctionList: any = [];
  selectedFunctionForSetup: any = [];
  selectedEmployeeId: any = [];
  getLocationsListForEssSetup() {
    if (this.selectedYear != null) {
      const test = this.selectedYear?.split('-');
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "endDate": this.selectedSurveyEndDate,
        "fromYear": test[0],
        "location": [],
        "toYear": test[1]
      }
      this.httpService.callPostService(this.config.getLocationsListForEssSetup, request).subscribe((data: any) => {
        this.getLocationList = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele,
            name: ele,
          }
          this.getLocationList.push(obj);
        });
      })
    }
  }
  getBandsListForEssSetup() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "endDate": this.selectedSurveyEndDate
    }
    this.httpService.callPostService(this.config.getBandsListForEssSetup, request).subscribe((data: any) => {
      this.getBandList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getBandList.push(obj);
      });
    })
  }
  getGradesListForEssSetup() {
    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "endDate": this.selectedSurveyEndDate
    }
    this.httpService.callPostService(this.config.getGradesListForEssSetup, request).subscribe((data: any) => {
      this.getGradeList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getGradeList.push(obj);
      });
    })
  }
  getDeptListForEssSetup() {
    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "endDate": this.selectedSurveyEndDate
    }
    this.httpService.callPostService(this.config.getDeptListForEssSetup, request).subscribe((data: any) => {
      this.getFunctionList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getFunctionList.push(obj);
      });
    })
  }
  onSelectLocationSetup() { }
  onDeSelectLocationSetup() {
    if (this.selectedLocationForSetup.length == 0) {
      this.selectedBandForSetup = [];
      this.getBandList = [];
      this.getGradeList = [];
      this.selectedGradeForSetup = [];
      this.getFunctionList = [];
      this.selectedFunctionForSetup = [];
      this.listOfEmployees = [];
      this.selectedEmployeeForReport = []
      this.listOfEmployeesForReport = [];
      this.getBandListForReport = [];
      this.getGradeListForReport = [];
      this.getFunctionListForReport = [];
    } else {
      if (this.selectedTypeTabName == 'Reports') {
        this.getBandsListForEssForReport();
      } else {
        this.getBandsListForEssSetup();
      }
    }
  }
  selectAllLocationSetup(data: any) {
    this.selectedLocationForSetup = data;
    if (this.selectedTypeTabName == 'Reports') {
      this.getBandsListForEssForReport();
    } else {
      this.getBandsListForEssSetup();
    }
  }
  onDeSelectAllLocationSetup() {
    this.selectedBandForSetup = [];
    this.getBandList = [];
    this.getGradeList = [];
    this.selectedGradeForSetup = [];
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
    this.listOfEmployees = [];
    this.selectedEmployeeForReport = []
    this.listOfEmployeesForReport = [];
    this.getBandListForReport = [];
    this.getGradeListForReport = [];
    this.getFunctionListForReport = [];
  }

  onSelectBandSetup() { }
  onDeSelectBandSetup() {
    if (this.selectedBandForSetup.length == 0) {
      this.getGradeList = [];
      this.selectedGradeForSetup = [];
      this.getFunctionList = [];
      this.selectedFunctionForSetup = [];
      this.selectedEmployeeForReport = []
      this.listOfEmployeesForReport = [];

      this.listOfEmployeesForReport = [];
      this.getGradeListForReport = [];
      this.getFunctionListForReport = [];
    } else {
      if (this.selectedTypeTabName == 'Reports') {
        this.getBandsListForEssForReport();
      } else {
        this.getBandsListForEssSetup();
      }
    }
  }
  selectAllBandSetup(data: any) {
    this.selectedBandForSetup = data;
    if (this.selectedTypeTabName == 'Reports') {
      this.getGradesListForEssForReport();
    } else {
      this.getGradesListForEssSetup();
    }
  }
  onDeSelectAllBandSetup() {
    this.getGradeList = [];
    this.selectedGradeForSetup = [];
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
    this.selectedEmployeeForReport = []
    this.listOfEmployeesForReport = [];
    this.getGradeListForReport = [];
    this.getFunctionListForReport = [];
  }

  onSelectGradeSetup() { }
  onDeSelectGradeSetup() {
    if (this.selectedGradeForSetup.length == 0) {
      this.getFunctionList = [];
      this.selectedFunctionForSetup = [];
      this.selectedEmployeeForReport = []
      this.listOfEmployeesForReport = [];
      this.getFunctionListForReport = [];
    } else {
      if (this.selectedTypeTabName == 'Reports') {
        this.getDeptListForEssForReport();
      } else {
        this.getDeptListForEssSetup();
      }
    }
  }
  selectAllGradeSetup(data: any) {
    this.selectedGradeForSetup = data;
    if (this.selectedTypeTabName == 'Reports') {
      this.getDeptListForEssForReport();
    } else {
      this.getDeptListForEssSetup();
    }
  }
  onDeSelectAllGradeSetup() {
    this.getFunctionList = [];
    this.selectedFunctionForSetup = [];
    this.selectedEmployeeForReport = []
    this.listOfEmployeesForReport = [];
    this.getFunctionListForReport = [];
  }

  onSelectFunctionSetup() { }
  onDeSelectFunctionSetup() {
    if (this.selectedFunctionForSetup.length == 0) {
      this.listOfEmployees = [];
      this.selectedEmployeeForReport = []
      this.listOfEmployeesForReport = [];
    } else {
      if (this.selectedTypeTabName == 'Reports') {
        this.getEmpListForEssForReport();
      } else {
        this.getEmpListForEssSetup();
      }
    }
  }
  selectAllFunctionSetup(data: any) {
    this.selectedFunctionForSetup = data;
  }
  onDeSelectAllFunctionSetup() {
    this.selectedFunctionForSetup = [];
  }
  questionResponses: any = []
  onClickRating(selectedquestion: any, selectedrating: any, questionIndex: any) {
    if (!this.isResponseSubmittedMySurvey) {
      this.mySurveyQuestionList[questionIndex].answer = selectedrating.rating;
    }
  }
  submitMySurveyResponse() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to Submit response?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var questionResponses: { answer: any; questionId: any; }[] = []
        this.mySurveyQuestionList.forEach((ele: any) => {
          let obj = {
            answer: ele.answer,
            questionId: ele.id
          }
          questionResponses.push(obj);
        })
        var flag = true;
        if (this.mySurveyQuestionList?.some((ele: any) => ele.answer == '')) { flag = false }
        if (!flag) {
          this.toastr.error('Please fill all mandetory fields.', '', {
            timeOut: 3000,
          });
          return
        }
        const request = {
          "essId": this.selectedSurveyID,
          "questionResponses": questionResponses,
          "userId": this.loggedInUserId
        }
        this.loader.simpleLoader();
        this.httpService.callPostService(this.config.submitMySurveyResponse, request).subscribe((data: any) => {
          this.loader.dismissLoader();
          if (data?.status) {
            this.isResponseSubmitted();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.isEditActive = false;
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {

            });
          }
        })
      }
    });
  }
  getResponseOfSurveyByEmployeeID() {
    this.httpService.callGetService(this.config.getResponseOfSurveyByEmployeeID + this.selectedSurveyID + '/' +
      this.loggedInUserId).subscribe((data: any) => {
        for (let i = 0; i < this.mySurveyQuestionList.length; i++) {
          for (let j = 0; j < data?.responses.length; j++) {
            if (this.mySurveyQuestionList[i].id == data?.responses[j].questionId)
              this.mySurveyQuestionList[i].answer = data?.responses[j].answer
          }
        }
      })
  }
  publishEss() {
    this.loader.simpleLoader();
    this.httpService.callGetService(this.config.publishEss + this.selectedSurveyID).subscribe((data: any) => {
      this.loader.dismissLoader();
      if (data?.status) {
        this.getessByID();
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: data.message,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
      } else {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: data.message,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
      }
    })
  }
  onChangeSurveyNameOfReport() {
    
    let selectedSurvey = this.essNamesList.find((ele: { id: any; }) => ele.id === this.selectedSurveyID);
    this.selectedSurveyName = selectedSurvey?.name;
    if (this.selectedSurveyID == null) {
      this.getCompletionReportList = [];
      this.questionWiseReportList = [];
      this.dimensionsWiseReportList = [];
      this.demographicWiseReportList = [];
      this.getScoreTrendReportList = [];
      return
    }
    if (this.selectedSubTab == 'Question Wise Report') {
      this.getQuestionWiseReport();
    }
    if (this.selectedSubTab == 'Dimension wise report') {
      this.getDimensionWiseReport();
    }
    if (this.selectedSubTab == 'Demographic Wise Report') {
      this.getDemographicWiseReport();
    }
    if (this.selectedSubTab == 'Score Trend') {
      this.getScoreTrendReport();
    }
    if (this.selectedSubTab == 'Completion Report') {
      this.getCompletionReport();
    }
    if (this.selectedSubTab == 'Master / Dump') {
      this.getMasterDumpReport();
    }
  }
  searchStringReport: any = null
  onSearchInputReport(event: any) {
    this.searchStringReport = event.target.value;
    if (this.searchStringReport == '') {
      this.searchStringReport = null;
    } if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.onChangeSurveyNameOfReport();
    }, 300);
  }
  noOfEmpsReport: any;
  totalAvgScoreOfSurveyReport: any;
  questionWiseReportList: any = [];
  dimensionsWiseReportList: any = [];
  demographicType: any = 'Department';
  demographicWiseReportList: any = [];
  columnsNamesOfDemographicsTable: any = [];
  getScoreTrendReportList: any = [];
  multipleSelectedEssIDs: any = [];
  getEmployeeListForReport: any = [];
  getCompletionReportList: any = [];
  demographicWiseReportAvgList: any = [];
  columnsNamesOfScoreTrendReport: any = [];
  getQuestionWiseReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "demographicType": null,
      "essId": [
        this.selectedSurveyID
      ],
      "fromYear": test[0],
      "search": this.searchStringReport,
      "toYear": test[1]
    }
    this.httpService.callPostService(this.config.getQuestionWiseReport, request).subscribe((data: any) => {
      this.noOfEmpsReport = data?.data?.noOfEmps ? data?.data?.noOfEmps : 0;
      this.totalAvgScoreOfSurveyReport = data?.data?.totalAvgScoreOfSurvey ? data?.data?.totalAvgScoreOfSurvey : 0;
      this.questionWiseReportList = data?.data?.response;
    })
  }
  getDimensionWiseReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "demographicType": null,
      "essId": [
        this.selectedSurveyID
      ],
      "fromYear": test[0],
      "search": this.searchStringReport,
      "toYear": test[1]
    }
    this.httpService.callPostService(this.config.getDimensionWiseReport, request).subscribe((data: any) => {
      this.noOfEmpsReport = data?.data?.noOfEmps ? data?.data?.noOfEmps : 0;
      this.totalAvgScoreOfSurveyReport = data?.data?.totalAvgScoreOfSurvey ? data?.data?.totalAvgScoreOfSurvey : 0;
      this.dimensionsWiseReportList = data?.data?.dimensions;

    })
  }
  getDemographicWiseReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "demographicType": this.demographicType,
      "essId": [
        this.selectedSurveyID
      ],
      "fromYear": test[0],
      "search": this.searchStringReport,
      "toYear": test[1],
    }
    this.httpService.callPostService(this.config.getDemographicWiseReport, request).subscribe((data: any) => {
      this.columnsNamesOfDemographicsTable = data?.data?.columns;
      this.demographicWiseReportList = data?.data?.data;
      this.demographicWiseReportAvgList = data?.data?.avgScore
    })
  }
  getScoreTrendReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "demographicType": null,
      "essId": this.multipleSelectedEssIDs?.map((ele: { id: any; }) => ele.id),
      "fromYear": test[0],
      "search": this.searchStringReport,
      "toYear": test[1],
    }
    this.httpService.callPostService(this.config.getScoreTrendReport, request).subscribe((data: any) => {
      this.columnsNamesOfScoreTrendReport = data?.data?.columns;
      this.getScoreTrendReportList = data?.data?.data;
    })
  }
  getCompletionReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "depts": this.selectedFunctionForSetup?.map((ele: { id: any; }) => ele.id),
      "essId": [
        this.selectedSurveyID
      ],
      "fromYear": test[1],
      "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "search": this.searchStringReport,
      "toYear": test[1],
      "userId": this.selectedEmployeeForReport?.map((ele: { id: any; }) => ele.id),
    }
    this.httpService.callPostService(this.config.getCompletionReport, request).subscribe((data: any) => {
      this.columnsNamesOfDemographicsTable = data?.data?.columns;
      
      this.getCompletionReportList = data?.data;
    })
  }
  getMasterDumpReportList: any = [];
  getMasterDumpReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": 0,
      "demographicType": null,
      "essId": this.multipleSelectedEssIDs?.map((ele: { id: any; }) => ele.id),
      "fromYear": test[0],
      "search": this.searchStringReport,
      "toYear": test[1]
    }
    this.httpService.callPostService(this.config.getMasterDumpReport, request).subscribe((data: any) => {
      this.getMasterDumpReportList = data?.data?.surveyDump;
    })
  }
  selectedEmployeeForReport: any = [];
  listOfEmployees: any = [];
  onSelectEmployeeRport() { }
  onDeSelectEmployeeRport() { }
  selectAllFunctionReport(data: any) {
    this.selectedFunctionForSetup = data;
    if (this.selectedTypeTabName == 'Reports') {
      this.getEmpListForEssForReport();
    } else {
      this.getEmpListForEssSetup();
    }
  }
  onDeSelectAllFunctionReport() {
    this.selectedFunctionForSetup = [];
    this.selectedEmployeeForReport = []
    this.listOfEmployeesForReport = [];
  }
  selectAllEmployeeRport(data: any) {
    this.selectedEmployeeForReport = data;
    this.getCompletionReport();
  }
  onDeSelectAllEmployeeRport() {
    this.selectedEmployeeForReport = [];
  }
  getEmpListForEssSetup() {
    
    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "depts": this.selectedFunctionForSetup?.map((ele: { id: any; }) => ele.id),
      "doj": null,
      "endDate": this.selectedSurveyEndDate,
    }
    this.httpService.callPostService(this.config.getEmpListForEssSetup, request).subscribe((data: any) => {
      this.listOfEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName,
        }
        this.listOfEmployees.push(obj);
      });
      
      this.selectedEmployeeForReport = this.listOfEmployees.filter((item: any) => this.selectedEmployeeForReport?.includes(item.id));
      if (this.selectedEmployeeForReport.length != 0 && this.selectedSubTab == 'Completion Report') {
        this.getCompletionReport();
      }
    })
  }
  validateInputRating(event: KeyboardEvent): void {
    const pattern = /^[0-9]$/; // Allows only digits (0-9).
    const inputChar = String.fromCharCode(event.keyCode || event.which);

    if (!pattern.test(inputChar)) {
      event.preventDefault(); // Prevent invalid character input.
    }
  }
  onClickEssName(data: any) {
    if (data?.essStatus == 'Pending') {
      this.router.navigate(['/home/hrportal/ess', { operation: 'Setup', id: data?.id, year: this.selectedYear }]);
    } else {
      this.selectedSurveyID = data?.id;
      this.onClickOpenCreateSurveyPopup('My Master')
    }
  }
  isAllSurveyMaster: boolean = false;
  selectedSurveyMaster: any = [];
  onSelectAllSurveyMaster(event: any) {
    this.selectedSurveyMaster = [];
    if (event.checked) {
      this.isAllSurveyMaster = true;
      this.listOfEss.forEach((ele: any) => {
        if (ele.essStatus != 'Active') {
          ele.isChecked = true
          this.selectedSurveyMaster.push(ele);
        }
      });
    } else {
      this.listOfEss.forEach((ele: any) => {
        ele.isChecked = false
      });
      this.isAllSurveyMaster = false;
      this.selectedSurveyMaster = [];
    }
  }
  onSelectSingleSurveyMaster(event: any, item: any, index: any) {
    if (event.checked) {
      this.listOfEss[index].isChecked = true;
      this.selectedSurveyMaster.push(item);
    } else {
      this.isAllSurveyMaster = false;
      this.listOfEss[index].isChecked = false;
      this.listOfEss.forEach((ele: any, ind: any) => {
        if (ele.isChecked == false) {
          this.selectedSurveyMaster.splice(ind, 1);
        }
      });
    }
  }
  demographicComparisonGraphData: any = [];
  completionStatusGraphData: any = [];
  dimensionComparisonData: any = [];
  trendAnalysisData: any = [];
  demographicTrendAnalysisData: any = [];
  getDemographicComparisonGraph() {
    const year = this.selectedYearForDemoGraphicGraph?.split('-');
    var essId = [];
    if (this.selectedSurveyIDForDemoGraphicGraph != null) {
      essId.push(this.selectedSurveyIDForDemoGraphicGraph)
    } else {
      this.demographicComparisonGraphData = []
      this.switchDemographicComparisonGraphType('bar');
      return;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "demographicType": this.selectedDemoGraphicTypeForDemoGraphicGraph,
      "essId": essId,
      "fromYear": year[0],
      "search": null,
      "toYear": year[1]
    }
    this.httpService.callPostService(this.config.getDemographicComparisonGraph, request).subscribe((data: any) => {
      this.demographicComparisonGraphData = []
      data?.data?.forEach((ele: any) => {
        let obj = {
          value: ele.score,
          name: ele.demographicName,
        }
        this.demographicComparisonGraphData.push(obj);
      });
      this.switchDemographicComparisonGraphType('bar');
    })
  }
  getCompletionStatusGraph() {
    const year = this.selectedYearForCompletionStatusGraph?.split('-');
    var essId = [];
    if (this.selectedSurveyIDForCompletionStatusGraph != null) {
      essId.push(this.selectedSurveyIDForCompletionStatusGraph)
    } else {
      this.completionStatusGraphData = []
      this.switchCompletionStatusGraphType('bar');
      return;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "demographicType": this.selectedDemoGraphicTypeForCompletionStatusGraph,
      "essId": essId,
      "fromYear": year[0],
      "search": null,
      "toYear": year[1]
    }
    this.httpService.callPostService(this.config.getCompletionStatusGraph, request).subscribe((data: any) => {
      this.completionStatusGraphData = []
      data?.data?.forEach((ele: any) => {
        let obj = {
          incomplete: ele.incomplete,
          submitted: ele.submitted,
          name: ele.demographicName,
        }
        this.completionStatusGraphData.push(obj);
      });
      this.switchCompletionStatusGraphType('bar');
    })
  }
  getDimensionComparisonGraph() {
    const year = this.selectedYearForDimensionComparisonGraph?.split('-');
    var essId = [];
    if (this.selectedSurveyIDForDimensionComparisonGraph != null) {
      essId.push(this.selectedSurveyIDForDimensionComparisonGraph)
    } else {
      this.dimensionComparisonData = []
      this.switchDimensionComparisonGraphType('bar');
      return;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "demographicType": null,
      "essId": essId,
      "fromYear": year[0],
      "search": null,
      "toYear": year[1]
    }
    this.httpService.callPostService(this.config.getDimensionComparisonGraph, request).subscribe((data: any) => {
      this.dimensionComparisonData = []
      data?.data?.forEach((ele: any) => {
        let obj = {
          value: ele.score,
          name: ele.dimensionName,
        }
        this.dimensionComparisonData.push(obj);
      });
      this.switchDimensionComparisonGraphType('bar');
    })
  }
  getTrendAnalysisGraph() {
    const year = this.selectedYearForTrendAnalysisGraph?.split('-');
    var essId = [];
    if (this.selectedSurveyIDForTrendAnalysisGraph != null) {
      essId.push(this.selectedSurveyIDForTrendAnalysisGraph)
    } else {
      this.trendAnalysisData = []
      this.switchTrendAnalysisGraphType('bar');
      return;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "demographicType": null,
      "essId": essId,
      "fromYear": year[0],
      "search": null,
      "toYear": year[1]
    }
    this.httpService.callPostService(this.config.getTrendAnalysisGraph, request).subscribe((data: any) => {
      this.trendAnalysisData = []
      data?.data?.forEach((ele: any) => {
        let obj = {
          value: ele.score,
          name: ele.surveyName,
        }
        this.trendAnalysisData.push(obj);
      });
      this.switchTrendAnalysisGraphType('bar');
    })
  }
  uniqueSurveyNames: any = []
  getDemographicTrendAnalysisGraph() {
    const year = this.selectedYearForDemoGraphicTrendAnalysisGraph?.split('-')
    if (this.selectedSurveyIDForDemoGraphicTrendAnalysisGraph.length == 0) {
      this.demographicTrendAnalysisData = [];
      this.switchDemographicTrendAnalysisGraphType('bar');
      return;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "demographicType": this.selectedDemoGraphicTypeForDemoGraphicTrendAnalysisGraph,
      "essId": this.selectedSurveyIDForDemoGraphicTrendAnalysisGraph?.map((ele: { id: any; }) => ele.id),
      "fromYear": year[0],
      "search": null,
      "toYear": year[1]
    }
    this.httpService.callPostService(this.config.getDemographicTrendAnalysisGraph, request).subscribe((data: any) => {
      this.demographicTrendAnalysisData = data?.data;
      this.uniqueSurveyNames = Array?.from(
        new Set(
          data?.data?.map((item: { surveys: any }) => item.surveys) // Get all surveys arrays
            .flat() // Flatten into a single array
            .map((survey: { surveyName: any }) => survey.surveyName) // Extract only surveyName
        )
      );
      this.switchDemographicTrendAnalysisGraphType('bar');
    })
  }
  noOfSurveysCreated: any = 0;
  noOfEmployees: any = 0;
  minScore: any = 0;
  maxScore: any = 0;
  avgScore: any = 0;
  noOfSurveysCreatedYearly: any = 0;
  noOfEmployeesYearly: any = 0;
  minScoreYearly: any = 0;
  maxScoreYearly: any = 0;
  avgScoreYearly: any = 0;
  getSurveyCounter() {
    
    const year = this.selectedYear?.split('-');
    if (this.selectedSurveyIDForDashboardGlobal != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "essId": this.selectedSurveyIDForDashboardGlobal,
        "fromYear": year[0],
        "toYear": year[1],
        "type": null
      }
      this.httpService.callPostService(this.config.getSurveyCounter, request).subscribe((data: any) => {
        this.noOfSurveysCreated = data?.data?.noOfSurveysCreated ? data?.data?.noOfSurveysCreated : 0;
        this.noOfEmployees = data?.data?.noOfEmployees ? data?.data?.noOfEmployees : 0;
        this.minScore = data?.data?.minScore ? data?.data?.minScore : 0;
        this.maxScore = data?.data?.maxScore ? data?.data?.maxScore : 0;
        this.avgScore = data?.data?.avgScore ? data?.data?.avgScore : 0;
      })
    } else {
      this.noOfSurveysCreated = 0;
      this.noOfEmployees = 0;
      this.minScore = 0;
      this.maxScore = 0;
      this.avgScore = 0;
    }
  }
  getYearlyCounter() {
    const year = this.selectedYear?.split('-')
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "essId": null,
      "fromYear": year[0],
      "toYear": year[1],
      "type": null
    }
    this.httpService.callPostService(this.config.getYearlyCounter, request).subscribe((data: any) => {
      this.noOfSurveysCreatedYearly = data?.data?.noOfSurveysCreated ? data?.data?.noOfSurveysCreated : 0;
      this.noOfEmployeesYearly = data?.data?.noOfEmployees ? data?.data?.noOfEmployees : 0;
      this.minScoreYearly = data?.data?.minScore ? data?.data?.minScore : 0;
      this.maxScoreYearly = data?.data?.maxScore ? data?.data?.maxScore : 0;
      this.avgScoreYearly = data?.data?.avgScore ? data?.data?.avgScore : 0;
    })
  }
  changeGlobalYear() {
    this.selectedYearForDemoGraphicGraph = this.selectedYear;
    this.selectedYearForCompletionStatusGraph = this.selectedYear;
    this.selectedYearForDimensionComparisonGraph = this.selectedYear;
    this.selectedYearForTrendAnalysisGraph = this.selectedYear;
    this.selectedYearForDemoGraphicTrendAnalysisGraph = this.selectedYear;
  }
  onSelectDemographicsGraphSurvey() {

  }
  onDeSelectDemographicsGraphSurvey() {

  }
  selectAllDemographicsGraphSurvey(data: any) {
    this.selectedSurveyIDForDemoGraphicTrendAnalysisGraph = data;
    this.getDemographicTrendAnalysisGraph()
  }
  onDeSelectAllDemographicsGraphSurvey() {
    this.selectedSurveyIDForDemoGraphicTrendAnalysisGraph = [];
  }
  isResponseSubmittedMySurvey: boolean = false;
  submissionDate: any;
  isResponseSubmitted() {
    const test = this.selectedYear?.split('-');
    this.httpService.callGetService(this.config.isResponseSubmitted + this.selectedSurveyID + '/' + this.loggedInUserId).subscribe((data: any) => {
      this.isResponseSubmittedMySurvey = data?.data?.isSubmit;
      this.submissionDate = data?.data?.submissionDate ? data?.data?.submissionDate : null;
    })
  }
  dashboardCounterPopups(popupName: any) {
    const successdialogRef = this.dialog.open(EssDashboardPopupsComponent, {
      disableClose: true,
      height: '30%',
      width: '70%',
      data: {
        popupName: popupName,
        selectedYear: this.selectedYear,
        selectedSurveyIDForDashboardGlobal: this.selectedSurveyIDForDashboardGlobal
      },
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }
  calculateRowspanForLocation(location: any): number {
    return location.bands.reduce((sum: number, band: any) => {
      return sum + this.calculateRowspanForBand(band);
    }, 0);
  }
  calculateRowspanForBand(band: any): number {
    return band.grades.reduce((sum: number, grade: any) => {
      return sum + this.calculateRowspanForGrade(grade);
    }, 0);
  }
  calculateRowspanForGrade(grade: any): number {
    return grade.depts.reduce((sum: any, dept: { employees: string | any[]; }) => {
      return sum + dept.employees.length;
    }, 0);
  }
  softDeleteEssByIds() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to delete Survey?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const request = {
          "id": this.selectedSurveyMaster?.map((ele: any) => ele.id),
          "isDeleted": true
        }
        this.httpService.callPostService(this.config.softDeleteEssByIds, request).subscribe((data: any) => {
          if (data?.data) {
            this.selectedSurveyMaster = [];
            this.isAllSurveyMaster = false;
            this.surveyMasterYearSelectionChange();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
            });
          }
        })
      }
    });
  }
  essNamesListForDashboard: any = [];
  selectedSurveyIDForDashboardGlobal: any;

  essNamesListForDashboardDemoGraphicsComparison: any = [];
  essNamesListForDashboardCompletionStatus: any = [];
  essNamesListForDashboardDimensionComparison: any = [];
  essNamesListForDashboardtrendAnalysis: any = [];
  essNamesListForDashboardDemoGraphicsTrendAnalysis: any = [];
  essNamesActiveAndCompleted() {
    const test = this.selectedYear?.split('-');
    this.httpService.callGetService(this.config.essNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.essNamesListForDashboard = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.essName,
        }
        this.essNamesListForDashboard.push(obj);
      });
      const filteredData = data.data?.filter((item: { isRecentCompleted: any; }) => item.isRecentCompleted);
      if (filteredData?.length != 0) {
        this.selectedSurveyIDForDashboardGlobal = filteredData[0]?.id;
        this.selectedSurveyIDForDemoGraphicGraph = filteredData[0]?.id;
        this.selectedSurveyIDForCompletionStatusGraph = filteredData[0]?.id;
        this.selectedSurveyIDForDimensionComparisonGraph = filteredData[0]?.id;
        this.selectedSurveyIDForTrendAnalysisGraph = filteredData[0]?.id;
      } else {
        this.selectedSurveyIDForDashboardGlobal = null;
        this.selectedSurveyIDForDemoGraphicGraph = null;
        this.selectedSurveyIDForCompletionStatusGraph = null;
        this.selectedSurveyIDForDimensionComparisonGraph = null;
        this.selectedSurveyIDForTrendAnalysisGraph = null;
      }
      this.selectedSurveyIDForDemoGraphicTrendAnalysisGraph = this.essNamesListForDashboard;
      this.multipleSelectedEssIDs = this.essNamesListForDashboard;
      this.essNamesListForDashboardDemoGraphicsComparison = this.essNamesListForDashboard;
      this.essNamesListForDashboardCompletionStatus = this.essNamesListForDashboard;
      this.essNamesListForDashboardDimensionComparison = this.essNamesListForDashboard;
      this.essNamesListForDashboardtrendAnalysis = this.essNamesListForDashboard;
      this.essNamesListForDashboardDemoGraphicsTrendAnalysis = this.essNamesListForDashboard;
      
      this.getSurveyCounter();
      this.getYearlyCounter();
      this.getDemographicComparisonGraph();
      this.getCompletionStatusGraph();
      this.getDimensionComparisonGraph();
      this.getTrendAnalysisGraph();
      this.getDemographicTrendAnalysisGraph();
    })
  }
  essNamesActiveAndCompletedDemoGraphicsComparison() {
    const test = this.selectedYearForDemoGraphicGraph?.split('-');
    this.httpService.callGetService(this.config.essNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      
      this.essNamesListForDashboardDemoGraphicsComparison = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.essName,
        }
        this.essNamesListForDashboardDemoGraphicsComparison.push(obj);
      });
      const filteredData = data.data?.filter((item: { isRecentCompleted: any; }) => item.isRecentCompleted);
      if (filteredData?.length != 0) {
        this.selectedSurveyIDForDemoGraphicGraph = filteredData[0]?.id;
      } else {
        this.selectedSurveyIDForDemoGraphicGraph = null
      }
      this.getDemographicComparisonGraph();
    })
  }
  essNamesActiveAndCompletedCompletionStatus() {
    const test = this.selectedYearForCompletionStatusGraph?.split('-');
    this.httpService.callGetService(this.config.essNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.essNamesListForDashboardCompletionStatus = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.essName,
        }
        this.essNamesListForDashboardCompletionStatus.push(obj);
      });
      const filteredData = data.data?.filter((item: { isRecentCompleted: any; }) => item.isRecentCompleted);
      if (filteredData?.length != 0) {
        this.selectedSurveyIDForCompletionStatusGraph = filteredData[0]?.id;
      } else {
        this.selectedSurveyIDForCompletionStatusGraph = null
      }
      this.getCompletionStatusGraph();
    })
  }
  essNamesActiveAndCompletedDimensionComparison() {
    const test = this.selectedYearForDimensionComparisonGraph?.split('-');
    this.httpService.callGetService(this.config.essNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.essNamesListForDashboardDimensionComparison = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.essName,
        }
        this.essNamesListForDashboardDimensionComparison.push(obj);
      });
      const filteredData = data.data?.filter((item: { isRecentCompleted: any; }) => item.isRecentCompleted);
      if (filteredData?.length != 0) {
        this.selectedSurveyIDForDimensionComparisonGraph = filteredData[0]?.id;
      } else {
        this.selectedSurveyIDForDimensionComparisonGraph = null
      }
      this.getDimensionComparisonGraph();
    })
  }
  essNamesActiveAndCompletedTrendAnalysis() {
    const test = this.selectedYearForTrendAnalysisGraph?.split('-');
    this.httpService.callGetService(this.config.essNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.essNamesListForDashboardtrendAnalysis = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.essName,
        }
        this.essNamesListForDashboardtrendAnalysis.push(obj);
      });
      const filteredData = data.data?.filter((item: { isRecentCompleted: any; }) => item.isRecentCompleted);
      if (filteredData?.length != 0) {
        this.selectedSurveyIDForTrendAnalysisGraph = filteredData[0]?.id;
      } else {
        this.selectedSurveyIDForTrendAnalysisGraph = null
      }
      this.getTrendAnalysisGraph();
    })
  }
  essNamesActiveAndCompletedDemographicTrendAnalysis() {
    const test = this.selectedYearForDemoGraphicTrendAnalysisGraph?.split('-');
    this.httpService.callGetService(this.config.essNamesActiveAndCompleted + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
      this.essNamesListForDashboardDemoGraphicsTrendAnalysis = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.essName,
        }
        this.essNamesListForDashboardDemoGraphicsTrendAnalysis.push(obj);
      });
      if (this.essNamesListForDashboardDemoGraphicsTrendAnalysis?.length != 0) {
        this.selectedSurveyIDForDemoGraphicTrendAnalysisGraph = this.essNamesListForDashboardDemoGraphicsTrendAnalysis;
      }
      else {
        this.selectedSurveyIDForDemoGraphicTrendAnalysisGraph = []
      }
      this.getDemographicTrendAnalysisGraph();
    })
  }
  changeGlobalSurveyId() {
    
    this.selectedSurveyIDForDemoGraphicGraph = this.selectedSurveyIDForDashboardGlobal;
    this.selectedSurveyIDForCompletionStatusGraph = this.selectedSurveyIDForDashboardGlobal;
    this.selectedSurveyIDForDimensionComparisonGraph = this.selectedSurveyIDForDashboardGlobal
    this.selectedSurveyIDForTrendAnalysisGraph = this.selectedSurveyIDForDashboardGlobal
    this.getSurveyCounter();
    this.getDemographicComparisonGraph();
    this.getCompletionStatusGraph();
    this.getDimensionComparisonGraph();
    this.getTrendAnalysisGraph();
    this.getDemographicTrendAnalysisGraph();
  }
  getScore(scores: any[], demographicName: string): string | null {
    const score = scores.find(
      (item) => item.demographicName === demographicName
    );
    return score ? score.score : null;
  }
  getAverageScore(column: string): number {
    const found = this.demographicWiseReportAvgList.find((avg: any) => avg.demographicName === column);
    return found ? found.score : 0;  // Return score if found, else return 0
  }
  getScoreOfScoretrend(scores: any[], surveyName: string): string | null {
    const score = scores.find(
      (item) => item.surveyName === surveyName
    );
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Super Admin') {
      return score ? `${score.score}[${score.noOfEmp}]` : null;
    } else {
      return score ? `${score.score}` : null;
    }
  }
  getScoreForGraph(surveys: any[], surveyName: string): string | null {
    const score = surveys.find(
      (item) => item.surveyName === surveyName
    );
    return score ? score.score : null;
  }
  disableCreateSurveyBtn() {
    if (this.selectedSurveyStartDate && this.selectedSurveyEndDate && (this.selectedSurveyStatus == 'Active' ||
      this.selectedSurveyStatus == 'Published_Not_Started')) {
      const today = new Date();
      const start = new Date(this.selectedSurveyStartDate);
      const end = new Date(this.selectedSurveyEndDate);
      today.setHours(0, 0, 0, 0);
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      return today.getTime() >= start.getTime() && today.getTime() <= end.getTime() && this.isSelectedYearIsSameYeartoCurrentYear;
    } else {
      if (this.isSelectedYearIsSameYeartoCurrentYear) {
        return false
      } else {
        return true
      }
    }
  }
  transformToYear(formYear: any, toYear: any) {
    if (formYear == toYear) {
      return `${formYear}`;
    } else {
      return `${formYear?.toString()}-${toYear.toString()?.slice(-2)}`;
    }
  }
  downloadReportExcel(id: any) {
    const tableId = id
    const table = document.getElementById(tableId) as HTMLTableElement;
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
    if (!table) {
      alert('Table not found!');
      return;
    }
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${tableId}_${formattedDate}.xlsx`);
    this.loader.dismissLoader()
  }
  getLocationListForReport: any = [];
  listOfEmployeesForReport: any = [];
  getBandListForReport: any = [];
  getGradeListForReport: any = [];
  getFunctionListForReport: any = [];
  getLocationsListEssReport() {
    if (this.selectedYear != null) {
      const test = this.selectedYear?.split('-');
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "endDate": this.selectedSurveyEndDate,
        "fromYear": test[0],
        "location": [],
        "toYear": test[1],
        "essId": this.selectedSurveyID
      }
      this.httpService.callPostService(this.config.getLocationsListEssReport, request).subscribe((data: any) => {
        this.getLocationListForReport = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele,
            name: ele,
          }
          this.getLocationListForReport.push(obj);
        });
      })
    }
  }
  getBandsListForEssForReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "endDate": this.selectedSurveyEndDate
    }
    this.httpService.callPostService(this.config.getBandsListEssReport, request).subscribe((data: any) => {
      this.getBandListForReport = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getBandListForReport.push(obj);
      });
    })
  }
  getGradesListForEssForReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "endDate": this.selectedSurveyEndDate
    }
    this.httpService.callPostService(this.config.getGradesListEssReport, request).subscribe((data: any) => {
      this.getGradeListForReport = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getGradeListForReport.push(obj);
      });
    })
  }
  getDeptListForEssForReport() {
    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "endDate": this.selectedSurveyEndDate
    }
    this.httpService.callPostService(this.config.getDeptsListEssReport, request).subscribe((data: any) => {
      this.getFunctionListForReport = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getFunctionListForReport.push(obj);
      });
    })
  }
  getEmpListForEssForReport() {
    
    const test = this.selectedYear?.split('-');
    const request = {
      "band": this.selectedBandForSetup?.map((ele: { id: any; }) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "grade": this.selectedGradeForSetup?.map((ele: { id: any; }) => ele.id),
      "location": this.selectedLocationForSetup?.map((ele: { id: any; }) => ele.id),
      "toYear": test[1],
      "depts": this.selectedFunctionForSetup?.map((ele: { id: any; }) => ele.id),
      "doj": null,
      "endDate": this.selectedSurveyEndDate,
    }
    this.httpService.callPostService(this.config.getEmpsListEssReport, request).subscribe((data: any) => {
      this.listOfEmployeesForReport = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName,
        }
        this.listOfEmployeesForReport.push(obj);
      });
      
      this.selectedEmployeeForReport = this.listOfEmployeesForReport.filter((item: any) => this.selectedEmployeeForReport?.includes(item.id));
      if (this.selectedEmployeeForReport.length != 0 && this.selectedSubTab == 'Completion Report') {
        this.getCompletionReport();
      }
    })
  }

  getScore1(employee: any, dimensionName: string, questionText: string): number | string {
    for (let dim of employee.dimensions) {
      if (dim.dimensionName === dimensionName) {
        for (let q of dim.questions) {
          if (q.questionText === questionText) {
            return q.score;
          }
        }
      }
    }
    return "-"; // If no score found, show "-"
  }

  // getAverage(dimensionName: string, questionText: string): number | string {
  //   // return this.questionAverages[`${dimensionName}-${questionText}`] || "-";
  // }

  latestSelectedDate: any = null; // Track last selected date
  selectedDatesForReminder: any[] = [];

  addDate(date: any) {
    if (!date) return;

    // Create a new Date object from the selected date
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0); // Normalize to midnight (local time)

    // Convert to 'YYYY-MM-DD' format without UTC shift
    const dateString = selectedDate.getFullYear() + '-' +
      String(selectedDate.getMonth() + 1).padStart(2, '0') + '-' +
      String(selectedDate.getDate()).padStart(2, '0');

    // Toggle date selection
    const index = this.selectedDatesForReminder.indexOf(dateString);
    if (index === -1) {
      this.selectedDatesForReminder.push(dateString);
    } else {
      this.selectedDatesForReminder.splice(index, 1);
    }
    if (this.selectedDatesForReminder.length === 0) {
      this.latestSelectedDate = null;
    }
    console.log(JSON.stringify(this.selectedDatesForReminder))
  }

  removeDate(date: any) {
    const dateString = new Date(date).toISOString().split('T')[0]; // Convert to 'YYYY-MM-DD'

    this.selectedDatesForReminder = this.selectedDatesForReminder.filter(d => d !== dateString);
    if (this.selectedDatesForReminder.length === 0) {
      this.latestSelectedDate = null;
    }
  }


  dateClass = (d: Date) => {
    const dateToCheck = new Date(d);
    dateToCheck.setHours(0, 0, 0, 0); // Normalize

    return this.selectedDatesForReminder.some(dateStr => {
      const storedDate = new Date(dateStr); // Convert back to Date
      storedDate.setHours(0, 0, 0, 0); // Normalize
      return storedDate.getTime() === dateToCheck.getTime();
    }) ? 'selected-date' : '';
  };


}
